export default __webpack_public_path__ + "static/media/Avatar-20.673c7cb3.svg";